import * as React from 'react'
import { SVGProps } from 'react'

const SvgWhatsapp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m12.5 36.5 1.794-6.663a12.313 12.313 0 0 1-1.295-8.532 12.337 12.337 0 0 1 4.625-7.291 12.393 12.393 0 0 1 16.175 1.045 12.318 12.318 0 0 1 1.257 16.12 12.375 12.375 0 0 1-7.25 4.706 12.4 12.4 0 0 1-8.57-1.18L12.5 36.5Zm7.062-4.29.416.247a10.02 10.02 0 0 0 12.111-1.47 9.952 9.952 0 0 0 1.672-12.054 9.99 9.99 0 0 0-4.826-4.258 10.023 10.023 0 0 0-6.43-.437 10.001 10.001 0 0 0-5.36 3.566 9.958 9.958 0 0 0-2.067 6.088 9.843 9.843 0 0 0 1.461 5.17l.262.43-1.003 3.719 3.764-1Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.674 25.603a2.064 2.064 0 0 0-1.765-.402c-.46.19-.756.909-1.052 1.268a.439.439 0 0 1-.565.127 7.996 7.996 0 0 1-3.997-3.416.478.478 0 0 1 .063-.663 2.76 2.76 0 0 0 .706-1.176c.03-.49-.083-.98-.324-1.409a3.296 3.296 0 0 0-1.024-1.542 1.415 1.415 0 0 0-1.519.232 3.115 3.115 0 0 0-1.08 2.466c.001.261.034.521.099.774.164.609.416 1.19.748 1.726.24.41.502.808.784 1.19a12.029 12.029 0 0 0 3.397 3.142c.665.416 1.376.754 2.118 1.007a4.7 4.7 0 0 0 2.465.388 2.962 2.962 0 0 0 2.231-1.655c.122-.265.16-.56.106-.846-.127-.584-.91-.93-1.39-1.211Z"
      fill="currentColor"
    />
  </svg>
)

export default SvgWhatsapp
